import { toast } from 'react-toastify';
import { api } from '../api';
import { AlertTriggersResponse } from '../../entities/Alert';

const EMPTY: AlertTriggersResponse = { total: 0, triggers: [] };

/** As leituras que abriram e reforçaram o alerta, da mais recente para a mais antiga. */
export const listAlertTriggers = async (
  alertId: string,
  limit = 20,
): Promise<AlertTriggersResponse> => {
  try {
    const { data } = await api.get(`/alerts/${alertId}/triggers`, {
      params: { limit },
    });

    return data;
  } catch (error) {
    toast.error('Aconteceu um problema. Entre em contato com o administrador.');

    return EMPTY;
  }
};
